module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.b06871f2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 940
// module chunks = 5